import { trackMetaEvent } from './metaPixel';
import { persistTrackingParams } from './trackingParams';

// Loads analytics/marketing scripts. Only call after the visitor accepted cookies (GDPR).
export function loadTracking() {
  // Keep the campaign parameters for the rest of the visit (e.g. after opening /privacy).
  persistTrackingParams();

  // 1. Google Analytics (gtag.js)
  const gaScript = document.createElement('script');
  gaScript.async = true;
  gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-GE4H595W8Y';
  document.head.appendChild(gaScript);

  const gaInitScript = document.createElement('script');
  gaInitScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-GE4H595W8Y', { 'anonymize_ip': true });
  `;
  document.head.appendChild(gaInitScript);

  // 2. Google Tag Manager (GTM)
  const script = document.createElement('script');
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-NMFNHZWF');`;
  document.head.appendChild(script);

  const noscript = document.createElement('noscript');
  noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NMFNHZWF"
  height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
  document.body.prepend(noscript);

  // 3. Meta Conversions API & Pixel - GDPR compliant PageView event
  trackMetaEvent({ eventName: 'PageView' });
}
